import "./App.css";
import { useEffect, useState } from "react";

import { Route, Routes, useLocation } from "react-router-dom"; 
import Loader from "./components/Loader/Loader";

import Header from "./secciones/Header/Header";
import WhatsAppButton from "./components/iconos_flotantes/wsp_flotante";
import CartFloatingButton from "./components/iconos_flotantes/CartFloatingButton";
import CartSidebar from "./components/Cart/CartSidebar";

// PÁGINAS
import Home from "./secciones/Home/Home";
import Footer from "./secciones/Footer/Footer";
import Services from "./secciones/Services/Services";
import Cursos from "./secciones/Cursos/Cursos";
import MiPerfil from "./secciones/MiPerfil/MiPerfil";
import MisCursos from "./secciones/MisCursos/MisCursos";
import MiCarrito from "./secciones/MiCarrito/MiCarrito";
import TyC from "./secciones/TyC/TyC";
import PrivacyPolicy from "./secciones/TyC/PoliticaPrivacidad";

import LoginModal from "./components/auth/LoginModal";
import CursoLanding from "./secciones/Cursos/CursoLanding/CursoLanding";
import ScrollToTop from "./utils/ScrollToTop";
// ICONOS
import { FaUserCircle, FaShoppingCart, FaSignOutAlt } from "react-icons/fa";

// ================= CONFIG =================
const API_BASE_URL = process.env.REACT_APP_API_URL;
const branch_beta = "beta";

function App() {
  console.log(`Renderizando App en rama: ${branch_beta}`);

  // ================= STATES =================
  const [courses, setCourses] = useState([]);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [purchasedCourses, setPurchasedCourses] = useState([]);

  const [isPageLoading, setIsPageLoading] = useState(false);
  const location = useLocation();

  // 🔥 2. EFECTO PARA DETECTAR CAMBIO DE PÁGINA
  useEffect(() => {
    setIsPageLoading(true); // Mostramos el loader

    // Le damos tiempo al navegador (ej. 600ms) para que procese el CSS y las imágenes
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [location.pathname]); // Este arreglo hace que se dispare al cambiar la URL

  // ================= INIT =================
  useEffect(() => {
    // Cargar cursos
    fetch(`${API_BASE_URL}/courses/list.php`)
      .then(res => res.json())
      .then(data => setCourses(data))
      .catch(err => console.error("Error cursos:", err));

    // Verificar sesión
    fetch(`${API_BASE_URL}/auth/me.php`, {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setUser(data.user);

          // 🔥 MAGIA: Si está logueado, pedimos los cursos que ya compró
          fetch(`${API_BASE_URL}/courses/my_courses.php`, { credentials: "include" })
            .then(r => r.json())
            .then(myCoursesData => {
              if (myCoursesData.status === 'success') {
                setPurchasedCourses(myCoursesData.cursos);
              }
            });
        } else {
          setUser(null);
          setPurchasedCourses([]); // Limpiamos si no hay sesión
        }
      })
      .catch(() => {
        setUser(null);
        setPurchasedCourses([]);
      });

    // Resultado de pago
    const query = new URLSearchParams(window.location.search);
    const status = query.get("payment_status");
    const orderId = query.get("order_id");
    const msg = query.get("msg");

    if (status) {
      if (status === "success") {
        alert(`🎉 Pago exitoso\nOrden #${orderId}`);
      } else {
        alert(`⛔ Error en el pago: ${msg}`);
      }
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  // ================= LOGOUT =================
  const logout = () => {
    fetch(`${API_BASE_URL}/auth/logout.php`, { credentials: "include" })
      .then(() => {
        setUser(null);
        window.location.reload();
      });
  };

  // ================= RENDER =================
  return (
    <>
      <ScrollToTop />
      {/* ELEMENTOS GLOBALES */}
      {isPageLoading && <Loader texto="Cargando..." />}

      <div 
        className="app-wrapper" 
        style={{ 
          opacity: isPageLoading ? 0 : 1, 
          transition: "opacity 0.4s ease",
          pointerEvents: isPageLoading ? "none" : "auto" 
        }}
      >
        <Header />

        <WhatsAppButton />
        {/* <CartFloatingButton onClick={() => setIsCartOpen(true)} /> */}
        <LoginModal 
          isOpen={isLoginOpen} 
          onClose={() => setIsLoginOpen(false)} 
        />

        {/* ================= RUTAS ================= */}
        <Routes>
          <Route
            path="/"
            element={
              <Home
                courses={courses}
                user={user}
                setIsCartOpen={setIsCartOpen}
              />
            }
          />

          <Route path="/servicios" element={<Services />} />
         <Route path="/cursos" element={<Cursos
            courses={courses}
            user={user}
            setIsCartOpen={setIsCartOpen}
            purchasedCourses={purchasedCourses}
            openLoginModal={() => setIsLoginOpen(true)} // 🔥 Agregamos esto
            />
          }
          />
          <Route path="/mi-perfil" element={<MiPerfil
            user={user}
            setUser={setUser} />} />
          <Route path="/mi-carrito" element={<MiCarrito
            user={user}
            setUser={setUser} />} />
          <Route path="/mis-cursos" element={<MisCursos
            user={user}
            purchasedCourses={purchasedCourses}
          />} />
          <Route
            path="/curso/:slug"
            element={
              <CursoLanding
                courses={courses}
                user={user}
                setIsCartOpen={setIsCartOpen}
                purchasedCourses={purchasedCourses}
                openLoginModal={() => setIsLoginOpen(true)} // 🔥 Agregamos esto
              />
            }
          />
          <Route path="/terminos-y-condiciones" element={<TyC />} />
          <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />

        </Routes>

        
        <CartSidebar
          isOpen={isCartOpen}
          onClose={() => setIsCartOpen(false)}
          user={user}
        />
        {/* 🔥 3. LE PASAMOS LA FUNCIÓN Y EL USUARIO AL FOOTER */}
        <Footer 
          user={user} 
          openLoginModal={() => setIsLoginOpen(true)} 
        />
      </div>

    </>
  );
}

export default App;
